import { SvgIcon, Text } from '@cinch-labs/design-system'
import styles from './finance-offer-card.module.css'
import Image from 'next/image'
import { ReactNode } from 'react'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

interface FinanceOfferCardProps {
  image: {
    src: string
    alt: string
  }
  banner: string
  title: string
  offerDetails: string[]
  footerText: string
  ctaButton?: ReactNode
}

export const FinanceOfferCard = ({
  image,
  banner,
  title,
  offerDetails,
  footerText,
  ctaButton,
}: FinanceOfferCardProps) => {
  const { trackEvent } = useAnalytics()
  const handleClick = () => {
    trackEvent({
      eventName: `Click on New Car Finance offer component`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: `new car finance offer`,
          value: title,
        },
      },
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <Image
          src={image.src}
          alt={image.alt}
          fill={true}
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
          }}
        />
      </div>
      <div className={styles.banner}>
        <Text className={styles.text}>{banner}</Text>
      </div>
      <div className={styles.infoSection}>
        <Text className={styles.title}>{title}</Text>
        <div className={styles.offerDetails}>
          {offerDetails.map((detail, index) => (
            <div key={index} className={styles.bulletPoint}>
              <SvgIcon name={'tick'} size={16} />
              <Text className={styles.text}>{detail}</Text>
            </div>
          ))}
        </div>
        {ctaButton ? (
          <div className={styles.ctaContainer} onClick={handleClick}>
            {ctaButton}
          </div>
        ) : (
          <Text className={styles.footerText}>{footerText}</Text>
        )}
      </div>
    </div>
  )
}
